import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=0275cc5b&"
import script from "./BaseDropdown.vue?vue&type=script&lang=ts&"
export * from "./BaseDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports